<template>
<div>
    <div class="add-button" v-on:click.prevent="act">
        <span class="icon-add"></span>
    </div>
    <primary-button :title="title" :act="act"></primary-button>
    </div>
</template>

<script>
import PrimaryButton from '@/components/shared/PrimaryButton'
export default {
    props: {
        act: Function,
        title: String
    },
    components: {
        PrimaryButton
    }
}
</script>

<style scoped lang="scss">

@use '../styles/theme.scss';

.add-button {
    cursor: pointer;
    width: 60px;
    height: 60px;
    border-radius: 60px;
    background-color: theme.$primary-color;
    position: fixed;
    bottom: calc(env(safe-area-inset-bottom) + 70px);
    right: 10px;
    z-index: 8;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

.add-button:hover {
    background-color: theme.$primary-color-dark;
}

.add-button span {
    font-size: 32px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

@media (max-width: 767px) { 
    .primary-button {
        display:none;
    }
    .add-button {
        display: initial;
    }
}

@media (min-width: 768px) { 
    .primary-button {
        display: block;
        position: absolute;
        top: 34px;
        right: 114px;
    }
    .add-button {
        display: none;
    }
}


</style>